import type { BaseController } from '@infra/controllers/base.controller';
import type { Contact } from '@salesforce/scv-connector-base';
import type { ShowTeamListUsecase } from './show-teamlist.usecase';

export type ShowTeamListInput = void;

export type ShowTeamListOutput = Contact[] | void;

export class ShowTeamListController
  implements BaseController<ShowTeamListInput, ShowTeamListOutput>
{
  constructor(private usecase: ShowTeamListUsecase) {}

  async handle(): Promise<ShowTeamListOutput> {
    return this.usecase.run();
  }
}
